import './property.css'

function Property({prop}) {
    return (
            <div className="price">
    <div className="header">{prop.title}</div>
    <div className="grey">$ {prop.cost}</div>
    <div className='price--list'>{prop.l1}</div>
    <div className='price--list'>{prop.l2}</div>
    <div className='price--list'>{prop.l3}</div>
    <div className='price--list'>{prop.l4}</div>
    <div className='price--list'>{prop.l5}</div>
  </div>
    )
}

export default Property
